import { CreativeBean, CreativeControllerApi, ItemResponseCreativeBeanObject, ListResponseCreativeBean } from 'src/api/api'
import { BaseApi, configuration } from '../../../api/BaseApi'

class CreativeApi extends BaseApi {
    api: CreativeControllerApi

    constructor() {
        super()
        this.api = new CreativeControllerApi(configuration, configuration.basePath, this.fetch)
    }

    list(size: number = 20, page: number = 1, sort, search, adGroup, active): Promise<ListResponseCreativeBean> {
        return this.call(() => this.api.creativeList(search, adGroup, active, { query: { size, page, sort } }))
    }

    all(): Promise<ListResponseCreativeBean> {
        return this.call(() => this.api.creativeList())
    }

    allByAdGroup(adGroupId, sort): Promise<ListResponseCreativeBean> {
        return this.call(() => this.api.creativeListByAdGroup(adGroupId, { query: { sort } }))
    }

    create(creative: CreativeBean, icon, file): Promise<ItemResponseCreativeBeanObject> {
        const data = this.getData(creative, icon, file)
        return this.call(() => this.formDataUpload('POST', '/api/creative', data))
    }

    createBulk(creative: CreativeBean, icon, files, sizes): Promise<ItemResponseCreativeBeanObject> {
        const data = this.getBulk(creative, icon, files, sizes)
        return this.call(() => this.formDataUpload('POST', '/api/creative/bulk', data))
    }

    edit(id: any, creative: CreativeBean, icon, file): Promise<ItemResponseCreativeBeanObject> {
        const data = this.getData(creative, icon, file);
        return this.call(() => this.formDataUpload('PUT', '/api/creative/' + id, data))
    }

    view(id: any): Promise<ItemResponseCreativeBeanObject> {
        return this.call(() => this.api.creative(id))
    }

    delete(id: number): Promise<void> {
        return this.call(() => this.api.deleteCreative(id))
    }

    async activate(id: any): Promise<void> {
        return this.call(() => this.api.activateCreative(id))
    }

    private getData(creative: CreativeBean, icon: File, file: File): FormData {
        const data = new FormData()
        data.append('bean', JSON.stringify(creative))
        icon && data.append('icon', icon)
        file && data.append('file', file)
        return data
    }

    private getBulk(creative: CreativeBean, icon: File, files: File[], sizes: number[]): FormData {
        const data = new FormData()
        data.append('bean', JSON.stringify(creative))
        icon && data.append('icon', icon)
        files && files.forEach(file => data.append('files', file))
        sizes && sizes.forEach(size => data.append('sizes', size.toString()))
        return data
    }

    private async formDataUpload(method: string, path: string, body: FormData) {

        const response = await fetch(configuration.basePath + path, { method, credentials: 'include', body })

        if (response.ok) {
            return await response.json()
        } else {
            throw response
        }
    }
}

const creativeApi = new CreativeApi()
export default creativeApi


// WEBPACK FOOTER //
// ./src/component/app/creative/CreativeApi.ts